import { compareDesc, parseISO } from 'date-fns';

import { DriveNode } from '@/drive/entities/DriveNode';

export function sortByCreatedAt(a: DriveNode, b: DriveNode): number {
  if (!a.createdAt) {
    return -1;
  }

  if (!b.createdAt) {
    return 1;
  }

  return compareDesc(parseISO(a.createdAt), parseISO(b.createdAt));
}
